module.exports = __webpack_public_path__ + "static/img/9.6e75014b.jpg";